import { render, staticRenderFns } from "./BookVideosPreview.vue?vue&type=template&id=f6b6d438&scoped=true"
import script from "./BookVideosPreview.vue?vue&type=script&lang=js"
export * from "./BookVideosPreview.vue?vue&type=script&lang=js"
import style0 from "./BookVideosPreview.vue?vue&type=style&index=0&id=f6b6d438&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b6d438",
  null
  
)

export default component.exports